/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import {
  GSuiteFolderType,
  LetterTemplateCopyDto,
  LetterTemplateDto,
  LetterTemplateSourceDto,
  LetterTemplateType,
} from './letter-template.dto';

export const LetterTemplateMapper = entity<LetterTemplateDto>({
  type: enumeration(LetterTemplateType),
});

export const LetterTemplateSourceMapper = entity<LetterTemplateSourceDto>({
  type: enumeration(LetterTemplateType),
});

export const LetterTemplateCopyMapper = entity<LetterTemplateCopyDto>({
  template: LetterTemplateSourceMapper,
  direction: enumeration(GSuiteFolderType),
});
